<template>
  <div>
    <base-header class="pb-6">
      <b-row align-v="center" class="py-4">
        <b-col cols="7" lg="6">
          <h6 class="h2 text-white d-inline-block mb-0">{{ year }} Economic Model</h6>
          <nav aria-label="breadcrumb" class="d-none d-md-inline-block ml-md-4">
            <route-bread-crumb></route-bread-crumb>
          </nav>
        </b-col>
        <b-col lg="6" cols="5" class="text-right">
          <base-button size="sm" type="neutral" @click="edit" v-if="economicModel.id">Edit</base-button>
          <base-button size="sm" type="neutral" v-b-toggle.filters>
            <span class="btn-inner--icon"><i class="fas fa-filter"></i></span>
              <span class="btn-inner--text">Filters</span>
          </base-button>
        </b-col>
      </b-row>
    </base-header>
    <b-container fluid class="mt--6">
      <b-collapse visible id="filters">
        <b-card>
          <base-input label="Year" label-for="yearInput">
            <el-select v-model="year">
              <el-option v-for="year in years"
                         :key="year.label"
                         :label="year.label"
                         :value="year.value">
              </el-option>
            </el-select>
          </base-input>
        </b-card>
      </b-collapse>
      <b-row v-if="economicModel.id">
        <b-col md="6">
          <overview :year="year"></overview>
        </b-col>
        <b-col md="6">
          <quarterly-goals :year="year"></quarterly-goals>
        </b-col>
      </b-row>
      <b-row class="justify-content-center" v-else>
        <b-col md="8">
          <b-card>
            <b-button block variant="danger" @click="edit">Create Economic Model</b-button>
          </b-card>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>
<script>
import { mapGetters } from 'vuex';
import RouteBreadCrumb from '@/components/Breadcrumb/RouteBreadcrumb';
import {Select, Option} from 'element-ui';
import Overview from './EconomicModel/Overview';
import QuarterlyGoals from './EconomicModel/QuarterlyGoals';

export default {
  components: {
    RouteBreadCrumb,
    [Select.name]: Select,
    [Option.name]: Option,
    Overview,
    QuarterlyGoals,
  },
  data() {
    return {
      year: new Date().getFullYear(),
      years: [
        { value: new Date().getFullYear() - 6, label: new Date().getFullYear() - 6 },
        { value: new Date().getFullYear() - 5, label: new Date().getFullYear() - 5 },
        { value: new Date().getFullYear() - 4, label: new Date().getFullYear() - 4 },
        { value: new Date().getFullYear() - 3, label: new Date().getFullYear() - 3 },
        { value: new Date().getFullYear() - 2, label: new Date().getFullYear() - 2 },
        { value: new Date().getFullYear() - 1, label: new Date().getFullYear() - 1 },
        { value: new Date().getFullYear(), label: new Date().getFullYear() },
        { value: new Date().getFullYear() + 1, label: new Date().getFullYear() + 1 },
        { value: new Date().getFullYear() + 2, label: new Date().getFullYear() + 2 },
        { value: new Date().getFullYear() + 3, label: new Date().getFullYear() + 3 },
      ],
    };
  },
  computed: {
    ...mapGetters({
      user: 'profile/user',
      economicModel: 'economicModel/economicModel',
      cos: 'cos/cos',
      subBasic: 'profile/subBasic',
      subStandard: 'profile/subStandard',
      subPremium: 'profile/subPremium',
    }),
    subscribed() {
      return this.subBasic || this.subStandard || this.subPremium;
    },
  },
  methods: {
    edit() {
      const path = this.$route.fullPath + '/' + this.year + '/edit';
      this.$router.push({
        path: path
      });
    }
  },
  created() {
    this.$store.dispatch('economicModel/get', {user: this.user.slug, year: this.year});
  },
  mounted() {
    document.title = this.year + ' Economic Model';
  },
  watch: {
    year(to, from) {
      this.$store.dispatch('economicModel/get', {user: this.user.slug, year: to});
      this.$store.dispatch('cos/get', {user: this.user.slug, year: to});
    }
  }
}
</script>